import physicalLabsImg from "public/pocCloud/physical-labs.png";
import { ListWithLabel } from "@/components/list";

export const INTRO_CONSTANTS = {
  title: "Physical Labs for SI, VAR & COE – Purpose-Built for Innovation",
  description: [
    "OneMind’s Physical Labs are dedicated environments where System Integrators (SI), Value-Added Resellers (VAR), and Centers of Excellence (COE) can design, test, and showcase complex IT solutions with complete control and flexibility.",
    "These labs replicate real-world infrastructure and enterprise conditions, enabling teams to confidently validate new technologies, perform rigorous testing, and fine-tune configurations before going live.",
  ],
  children: (
    <ListWithLabel
      points={[
        {
          label: "Hands-On Testing & Development Environment",
          text: "Access enterprise-grade hardware and software stacks to build, integrate, and refine solutions.",
        },
        {
          label: "Simulate Real-World IT Infrastructure",
          text: "Mimic client production environments to identify risks, uncover limitations, and ensure deployment-readiness.",
        },
        {
          label: "Improve Solution Efficiency Before Deployment",
          text: "Reduce post-deployment issues by validating performance and compatibility early in the lifecycle.",
        },
      ]}
    />
  ),
  image: physicalLabsImg,
  imageHeight: "440px",
};
